// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pwu4","top":"styles_top__3GCru"};